import * as React from 'react';
import Translate from "../../functions/translate";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSyncAlt, faDownload } from '@fortawesome/free-solid-svg-icons';

const iconButton = (props) => {
    // type: primary, secondary, success, danger, warning, info, light, dark
    return (
        <div style={{ display: 'flex', marginRight: 10, minWidth: props.minWidth ? 300 : 'unset' }}>
            <div style={{ display: "flex", marginBottom: "10px", padding: "5px", width: 200 }}>
                <div style={{ paddingRight: '10px' }}>
                    <img src={props.icon} style={{ height: "42px" }} alt="pdf"></img>
                </div>
                <div>
                    <div>
                        {props.name}
                    </div>
                    {props.withoutGenerate ?
                        <div style={{ color: '#999', fontSize: '.9em' }}>
                            {props.size} | {props.type}
                        </div> : <a href="/" onClick={(e) => {
                            e.preventDefault();
                            props.generate();
                        }}>{Translate('Generate')}</a>}
                    {props.canSendMail ?
                        <a href="/" onClick={(e) => {
                            e.preventDefault();
                            props.sendMailClick();
                        }}>{Translate('SendEmail')}</a>
                        : null}
                </div>
            </div>
            <div style={{ display: 'flex' }}>
                {props.canDownload ?
                    <a href="/" onClick={(e) => {
                        e.preventDefault();
                        props.downloadClick();
                    }} style={{ padding: 10 }}>
                        <FontAwesomeIcon icon={faDownload} size="2x" />
                    </a>
                    : null}
                {props.withSynch && props.synchCondition ?
                    < a href="/"
                        onClick={(e) => {
                            e.preventDefault();
                            props.onSyncClick();
                        }
                        } style={{ padding: 10 }}>
                        <FontAwesomeIcon icon={faSyncAlt} size="2x" />
                    </a>
                    : <div />}
            </div>
        </div>
    )
}

export default iconButton;